import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Copy, Minimize2 } from 'lucide-react';
import { toast } from 'sonner';

const HtmlMinifierTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [stats, setStats] = useState(null);

  const minify = () => {
    if (!input.trim()) {
      toast.error('Please enter HTML to minify');
      return;
    }

    const originalSize = input.length;
    
    let minified = input
      .replace(/\n/g, '')
      .replace(/\r/g, '')
      .replace(/\t/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/>\s+</g, '><')
      .replace(/<!--[\s\S]*?-->/g, '')
      .trim();

    const minifiedSize = minified.length;
    const savings = ((originalSize - minifiedSize) / originalSize * 100).toFixed(1);

    setOutput(minified);
    setStats({ originalSize, minifiedSize, savings });
    toast.success('HTML minified!');
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  return (
    <div className="space-y-4" data-testid="html-minifier-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">HTML Minifier</h3>
      </div>

      <Textarea
        placeholder="Paste your HTML here..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="min-h-[150px] bg-background/50 font-mono text-sm"
        data-testid="input"
      />

      <Button onClick={minify} className="w-full" data-testid="minify-btn">
        <Minimize2 className="w-4 h-4 mr-2" />
        Minify HTML
      </Button>

      {stats && (
        <div className="grid grid-cols-3 gap-2 text-center">
          <div className="p-2 rounded bg-background/50 border border-border">
            <div className="text-lg font-bold">{stats.originalSize}</div>
            <div className="text-xs text-muted-foreground">Original</div>
          </div>
          <div className="p-2 rounded bg-background/50 border border-border">
            <div className="text-lg font-bold">{stats.minifiedSize}</div>
            <div className="text-xs text-muted-foreground">Minified</div>
          </div>
          <div className="p-2 rounded bg-emerald-500/20 border border-emerald-500/30">
            <div className="text-lg font-bold text-emerald-400">{stats.savings}%</div>
            <div className="text-xs text-muted-foreground">Saved</div>
          </div>
        </div>
      )}

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Minified Output</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[100px] bg-background/50 font-mono text-sm"
            data-testid="output"
          />
        </div>
      )}
    </div>
  );
};

export default HtmlMinifierTool;
